import { gql } from '@apollo/client';

export const fetchGetPlanNames = gql`
    query getPlanNames($dim2AttributeName: SamyaString!) {
        getPlanNames(dim2AttributeName: $dim2AttributeName) {
            plansList {
                planName
                planId
                dim1AttributeName
                dim2AttributeName
                saveType
            }
            errorMsg
        }
    }
`;

export const summaryDrilldownData = gql`
    query getPlansSummaryGraph($planIds: [Int]!, $attributeType: String!, $dimension: String!, $kpiName: String!) {
        getPlansSummaryGraph(
            planIds: $planIds
            attributeType: $attributeType
            dimension: $dimension
            kpiName: $kpiName
        ) {
            distinctPlans
            data {
                attributeName
                value
                type
            }
        }
    }
`;

export const fetchGetPromptList = gql`
    query getPromptsList(
        $filters: JSONString!
        $selectedField: SamyaString!
        $eventData: JSONString!
        $isEdit: Boolean!
        $planId: Int!
        $dim2AttributeName: SamyaString!
        $frequency: String
    ) {
        getPromptsList(
            filters: $filters
            selectedField: $selectedField
            eventData: $eventData
            isEdit: $isEdit
            planId: $planId
            dim2AttributeName: $dim2AttributeName
            frequency: $frequency
        ) {
            dim1Id
            promptName
            roi
            uplift
        }
    }
`;
export const fetchEventPromptsList = gql`
    query getEventPromptsList($filters: JSONString!, $frequency: String) {
        getEventPromptsList(filters: $filters, frequency: $frequency) {
            eventName
            promotionMechanic
            roi
            uplift
            featureAcv
            displayAcv
        }
    }
`;

export const fetchBaselineData = gql`
    query getBaselineData($eventData: JSONString!, $frequency: String) {
        getBaselineData(eventData: $eventData, frequency: $frequency) {
            baseVolume
        }
    }
`;

export const importEvents = gql`
    mutation importEvents($eventIds: [Int]!, $planId: Int!) {
        importEvents(eventIds: $eventIds, planId: $planId) {
            operationStatus
        }
    }
`;

export const fetchImportEventList = gql`
    query getEventsList($planId: Int!) {
        getEventsList(planId: $planId) {
            eventName
            eventId
        }
    }
`;

export const fetchEventsList = gql`
    query getPlanEventsData($planId: Int!, $frequency: String) {
        getPlanEventsData(planId: $planId, frequency: $frequency) {
            eventsData {
                visibleEventData {
                    eventBasicFields {
                        planId
                        eventName
                        eventId
                        startDate
                        endDate
                        dim1AttributeNames
                        dim2AttributeNames
                        activeStatus
                        parentId
                    }
                    eventHoverData {
                        startDate
                        duration
                        tacticDescription
                        dim1AttributeNames
                        totalGsv
                        totalNsv
                        totalProfit
                        promoSpends
                        percentageTradeSpendsGsv
                        percentageTradeSpendsNsv
                        totalProfitPercentage
                        incrementalGsv
                        incrementalNsv
                        incrementalProfit
                        incrementalVolume
                        retailerIncrementalProfit
                        baseVolume
                        totalVolume
                        totalKindProfit
                        roi
                        totalRetailerProfit
                        macPerUnit
                        nsvPerUnit
                        gsvPerUnit
                        macPromoUnit
                    }
                }
                eventDetailsData {
                    planId
                    eventName
                    eventId
                    startDate
                    duration
                    spendsData
                    promotionMechanic
                    tacticDescription
                    displayAcv
                    featureAcv
                    baseVolume
                    totalVolume
                    offerMethod
                    discount
                    promptEventName
                    totalKindProfit
                    totalRetailerProfit
                    roi
                    uplift
                    totalGsv
                    dim1Data {
                        dim1Id
                        dim1Name
                        openStock
                        shipperStock
                    }
                    dim2Ids
                    dim2AttributeNames
                    parentId
                    promoSpends
                }
            }
            calendarDetailsData {
                startDates
                endDates
            }
        }
    }
`;

export const deleteEvent = gql`
    mutation updateEvents(
        $eventsData: [JSONString]!
        $operationType: SamyaString!
        $planId: Int!
        $frequency: String!
    ) {
        updateEvents(eventsData: $eventsData, operationType: $operationType, planId: $planId, frequency: $frequency) {
            operationStatus
        }
    }
`;

export const updatePlan = gql`
    mutation updatePlan($metaData: JSONString!, $operationType: SamyaString!, $planId: Int!) {
        updatePlan(metaData: $metaData, operationType: $operationType, planId: $planId) {
            operationStatus
        }
    }
`;

export const updateEvents = gql`
    mutation updateEvents(
        $eventsData: [JSONString]!
        $operationType: SamyaString!
        $planId: Int!
        $frequency: String!
    ) {
        updateEvents(eventsData: $eventsData, operationType: $operationType, planId: $planId, frequency: $frequency) {
            operationStatus
        }
    }
`;

export const getSummaryData = gql`
    query getPlansSummary($planIds: [Int]!) {
        getPlansSummary(planIds: $planIds) {
            planName
            totalGsv
            totalNsv
            totalProfit
            promoSpends
            percentageTradeSpendsGsv
            percentageTradeSpendsNsv
            incrementalGsv
            incrementalNsv
            totalProfitPercentage
            incrementalProfit
            incrementalVolume
            retailerIncrementalProfit
            baseVolume
            totalVolume
            totalKindProfit
            roi
            totalRetailerProfit
            gsvPerUnit
            nsvPerUnit
            macPerUnit
        }
    }
`;

export const getPlaybookData = gql`
    query getPlaybookData($planId: Int!, $limit: Int!, $offset: Int!, $frequency: String) {
        getPlaybookData(planId: $planId, limit: $limit, offset: $offset, frequency: $frequency) {
            totalData {
                ppgName
                guidelinePercentageTotalSpends
                percentageTotalSpends
                frequency
                guidelineFrequency
                roi
                guidelineRoi
            }
            playbookData {
                ppgName
                guidelinePercentageTotalSpends
                percentageTotalSpends
                frequency
                guidelineFrequency
                roi
                guidelineRoi
            }
            totalCount
        }
    }
`;

export const getBaselineUpliftData = gql`
    query getUpliftAndBaseline(
        $eventData: JSONString!
        $planId: Int!
        $dim2AttributeName: SamyaString!
        $frequency: String
    ) {
        getUpliftAndBaseline(
            eventData: $eventData
            planId: $planId
            dim2AttributeName: $dim2AttributeName
            frequency: $frequency
        ) {
            uplift
            baseVolume
        }
    }
`;

export const getAdditionalKpis = gql`
    query getAdditionalModelRecommendedKpis($eventData: JSONString!, $frequency: String) {
        getAdditionalModelRecommendedKpis(eventData: $eventData, frequency: $frequency) {
            roi
            totalKindProfit
            totalRetailerProfit
            promoSpends
            totalGsv
        }
    }
`;

export const getBestWeeksData = gql`
    query getBestWeeksData(
        $dimension: String!
        $attributeName: String!
        $filters: JSONString!
        $limit: Int!
        $offset: Int!
        $rankingCriteria: String!
        $hideGapInSales: Boolean
    ) {
        getBestWeeksData(
            dimension: $dimension
            attributeName: $attributeName
            filters: $filters
            limit: $limit
            offset: $offset
            rankingCriteria: $rankingCriteria
            hideGapInSales: $hideGapInSales
        ) {
            weeksEventsMapping
            weeksData {
                attributeName
                values
            }
            totalCount
        }
    }
`;

export const updateEventName = gql`
    mutation UpdateEventName($eventId: Int!, $updatedName: SamyaString!) {
        updateEventName(eventId: $eventId, updatedName: $updatedName) {
            success
            message
        }
    }
`;
